import { Suspense } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../lib/auth';
import { TabBar } from './TabBar';
import { Spinner } from './ui';

/** Layout das rotas protegidas: conteúdo + barra de abas. Sem sessão → /login (10.1). */
export function AppShell({ tabs = true }: { tabs?: boolean }) {
  const { user, loading } = useAuth();
  const loc = useLocation();
  if (loading) return <Spinner />;
  if (!user) return <Navigate to="/login" replace state={{ from: loc.pathname + loc.search }} />;
  return (
    <div className="screen">
      <main style={{ flex: 1, display: 'flex', flexDirection: 'column', paddingBottom: 24 }}>
        <Suspense fallback={<Spinner />}>
          <Outlet />
        </Suspense>
      </main>
      {tabs && <TabBar />}
    </div>
  );
}
